import React from 'react';
import styled from 'styled-components';
import { colors } from '@com/core/kul/styles/kulTheme';

type TComponentRowContainerProps = {
    paddingTop: string;
    paddingBottom: string;
    color?: string;
    marginTop: string;
};

const ComponentRowContainer = styled.div<TComponentRowContainerProps>`
    position: relative;
    margin-top: ${(props): string => `${props.marginTop || 0}`};
    padding-top: ${(props): string => `${props.paddingTop || 20}px`};
    padding-right: 0;
    padding-bottom: ${(props): string => `${props.paddingBottom || 20}px`};
    padding-left: 0;
    color: ${(props): string => props.color || colors.body};
`;

type TProps = {
    children: JSX.Element;
    outerSpacing?: {
        top: number;
        bottom: number;
    };
    textColor?: string;
    multiComponentStyles?: { marginTop: string; paddingTop?: string };
};

const ComponentRow = ({ children, multiComponentStyles, outerSpacing, textColor }: TProps): JSX.Element => {
    const { bottom, top } = outerSpacing || {};

    return (
        <ComponentRowContainer
            marginTop={`${multiComponentStyles?.marginTop}`}
            color={textColor}
            paddingTop={`${top}`}
            paddingBottom={`${bottom}`}>
            {children}
        </ComponentRowContainer>
    );
};

export default ComponentRow;
